import React from "react";
import SntLink from "@/components/ReactBootstrap/SntLink";

// Re-export type for external use
export type HelpSidebarLinkUrl = string | { pathname: string };

interface HelpSidebarLink {
  text: string;
  url: HelpSidebarLinkUrl;
}

interface HelpSidebarItemProps {
  description?: string;
  linkText?: string;
  linkUrl?: HelpSidebarLinkUrl;
  links?: HelpSidebarLink[];
  htmlContent?: string;
}

const HelpSidebarItem: React.FC<HelpSidebarItemProps> = ({
  description,
  linkText,
  linkUrl,
  links,
  htmlContent,
}) => {
  if (htmlContent) {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: htmlContent,
        }}
      />
    );
  }

  return (
    <>
      {description && <p className="mb-0">{description}</p>}
      {linkText && linkUrl && (
        <SntLink target="_blank" to={linkUrl}>
          {linkText}
        </SntLink>
      )}
      {links && links.length > 0 && (
        <div className="d-flex gap-3">
          {links.map((link) => (
            <SntLink key={link.text} target="_blank" to={link.url}>
              {link.text}
            </SntLink>
          ))}
        </div>
      )}
    </>
  );
};

export default HelpSidebarItem;
